import { useNavigate } from "react-router-dom"
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material"

import {
    AccountBalanceWalletOutlined,
    BuildCircleOutlined,
    DirectionsCarFilledOutlined,
    EventAvailableOutlined,
    ShieldOutlined,
    SupportAgentOutlined,
} from "@mui/icons-material"

import { homeCopy } from "../../../content/homeCopy"

const benefitIcons = [
    DirectionsCarFilledOutlined,
    EventAvailableOutlined,
    ShieldOutlined,
    BuildCircleOutlined,
    AccountBalanceWalletOutlined,
    SupportAgentOutlined,
]

const WhatsIncluded = () => {
    const navigate = useNavigate()
    const benefits = homeCopy.whatsIncluded.benefits.map((benefit, index) => ({
        ...benefit,
        icon: benefitIcons[index],
    }))

    return (
        <Box
            component="section"
            id="whats-included"
            sx={{
                py: { xs: 6, md: 8 },
                background: "linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%)",
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} alignItems="flex-start">
                    <Grid item xs={12} md={4}>
                        <Stack spacing={2} data-aos="fade-right" data-aos-duration="800">
                            <Typography variant="h4" fontWeight={800} color="#000435">
                                Why Stargate Rentals?
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                {homeCopy.whatsIncluded.intro}
                            </Typography>
                            <Box>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="large"
                                    onClick={() => navigate("/vehicles")}
                                    sx={{ borderRadius: 999, px: 3, textTransform: "none", fontWeight: 700 }}
                                >
                                    Browse available vehicles
                                </Button>
                            </Box>
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Grid container spacing={2}>
                            {benefits.map(({ title, body, icon: Icon }, index) => (
                                <Grid item xs={12} sm={6} key={title}>
                                    <Box
                                        data-aos="fade-up"
                                        data-aos-delay={index * 60}
                                        data-aos-duration="700"
                                        sx={{
                                            height: "100%",
                                            p: 2.5,
                                            borderRadius: 2,
                                            border: "1px solid",
                                            borderColor: "rgba(0, 4, 53, 0.12)",
                                            background: "rgba(255,255,255,0.9)",
                                        }}
                                    >
                                        <Stack spacing={1.25}>
                                            <Box
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: 1.5,
                                                    display: "grid",
                                                    placeItems: "center",
                                                    background: "rgba(0, 163, 255, 0.12)",
                                                    color: "#00A3FF",
                                                }}
                                            >
                                                <Icon />
                                            </Box>
                                            <Typography variant="h6" fontWeight={700} color="#000435">
                                                {title}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {body}
                                            </Typography>
                                        </Stack>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default WhatsIncluded
